$(document).ready(function() {
    $(document).on('click', '.eq-pdp--atc', function(e) {
        e.preventDefault();
        let UID = +new Date() + Math.floor(Math.random() * 1000);
        let variant_id = $('.variant-selector option:selected').val();
        let upsellSubId = $('.upsell-subscription--product').attr('data-upsell-id');
        let upsellSellingId = $('.upsell-subscription--product').attr('data-upsell-selling-plan');
        let quantity = 1;
        var properties = {};
        if ($('.upsell-subscription--product').is(':checked')) {
            properties['_uid'] = UID;
        }
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            dataType: 'json',
            data: {
                id: variant_id,
                quantity: quantity,
                properties: properties
            },
            success: function(data) {
                if ($('.upsell-subscription--product').is(':checked')) {
                    $.ajax({
                        type: "POST",
                        url: "/cart/add.js",
                        data: {
                            quantity: 1,
                            id: upsellSubId,
                            selling_plan: upsellSellingId,
                            properties: {
                                '_uid': UID
                            }
                        },
                        dataType: "json",
                        success: function(response) {
                            window.location = '/cart';
                        },
                        error: function(error) {
                            console.error("Error adding product:", error);
                        }
                    });
                } else {
                    window.location = '/cart';
                }

            },
            error: function(data) {
                alert(data.responseJSON.description);
            }
        });
    });

    $(document).on('click', '.js_cart--remove', function(e) {
        e.preventDefault();
        let current_em = $(e.target);
        let key = $(this).attr('data-item-key');
        let updated_qty = 0;
        let current_item = {};
        var currentTemplate = $(this).attr('data-cart');
        let currentUID = $(current_em).parents(`[data-uid]`).attr('data-uid');
        if (currentUID.toString().trim() !== "") {
            $(`[data-uid='${currentUID}']`).each(function(ix, em) {
                let key2 = $(em).attr('data-key');
                 current_item[key2] = updated_qty;
            });
        } else {
            current_item[key] = updated_qty;
        }
        console.log('current_item ' + current_item)
        $.ajax({
            url: "/cart/update.js",
            data: {
                'updates': current_item
            },
            method: "POST",
            dataType: "JSON",
            success: function(data) {
                if (currentTemplate == 'true') {
                    $("#cart_form").eq(0).submit();
                } else {
                    $("#cart_form").eq(0).submit();
                }
            },
            error: function(error) {
                console.log(error)
            }
        });
    })

});